<template>
  <div>
    <div class="d-flex flex-row px-2">
      <div
        :style="{ visibility: $slots.contents ? 'visible' : 'hidden' }"
        class="pe-2 d-flex"
        style="cursor: pointer"
        @click="toggle"
      >
        <plus-circle-icon v-if="!expanded_state" class="icon-big py-auto" />
        <minus-circle-icon v-else class="icon-big py-auto" />
      </div>
      <div class="flex-grow-1" style="padding-top: 1px">
        <slot />
      </div>
    </div>
    <slot v-if="expanded_state" name="contents" />
  </div>
</template>

<script>
  export default {
    name: 'Expandable',
    props: {
      expanded: { type: Boolean, default: false },
      expandedBind: { type: Boolean, default: undefined },
    },
    emits: ['toggled', 'collapsed', 'expanded'],
    data() {
      return { expanded_: false, using_bind: false }
    },
    computed: {
      expanded_state() {
        if (this.using_bind) {
          return this.expandedBind || false
        }
        return this.expanded_
      },
    },
    beforeMount() {
      this.expanded_ = this.expanded || false
    },
    mounted() {
      if (this.expandedBind !== undefined) {
        this.using_bind = true
      }
    },
    methods: {
      toggle() {
        if (this.using_bind) {
          if (this.expanded_state) {
            this.$emit('toggled', false)
            this.$emit('collapsed', true)
          } else {
            this.$emit('toggled', true)
            this.$emit('expanded', true)
          }
        } else {
          this.expanded_ = !this.expanded_
        }
      },
    },
  }
</script>

<style scoped></style>
